import { h } from 'preact';
import { deviceVariance } from '@cube/blocks';
import { withConfig } from '../../config';
import { applyCurrent } from '../configfromcurrent';
import Mobile from './mobile';
import Desktop from './desktop';


const MobileWithCurrent = applyCurrent()(Mobile);
const DesktopWithCurrent = applyCurrent()(Desktop);

const Header = deviceVariance({
	phone: MobileWithCurrent,
	tablet: MobileWithCurrent
})(DesktopWithCurrent);

const conf = withConfig([
	'headerWidget.device',
	'headerWidget.theme',
	'headerWidget.useThemeFromWindow',
	'headerWidget.home',
	'headerWidget.current',
	'headerWidget.allowHideNavigation',
	'headerWidget.track'
]);

// Fully responsive header
export default conf(Header);

// Mobile only header
export const MobileHeader = conf(MobileWithCurrent);

// Desktop only header
export const DesktopHeader = conf(DesktopWithCurrent);
